import { useQuery } from 'react-query'
import { getSupplies } from 'lib/api/supplies/getSupplies'

export const suppliesQueryKey = ['supplies']

export function useGetSuppliesQuery() {
  return useQuery(suppliesQueryKey, () => getSupplies())
}
